import '../styles.scss'
import React, { useState, useRef, useCallback, useEffect } from 'react'
import 'react-html5-camera-photo/build/css/index.css'
import Modal from '../../Modals'
import { Button } from 'reactstrap'
import Webcam from 'react-webcam'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

// eslint-disable-next-line react/display-name
export default ({ showCamera, onCloseModal, sendData, uploading }) => {
  const onToggleCamera = () => {
    setRecordedChunks([])
    setShowingVideo(false)
    onCloseModal(false)
  }

  const mime = 'video/webm; codecs=opus,vp8'
  const mimeToSend = 'video/webm'
  const webcamRef = useRef(null)
  const mediaRecorderRef = useRef(null)
  //  const videroRef = useRef(null);

  const [capturing, setCapturing] = useState(false)
  const [recordedChunks, setRecordedChunks] = useState([])

  const handleStartCaptureClick = useCallback(() => {
    setCapturing(true)
    setShowingVideo(false)
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, { mimeType: mime })
    mediaRecorderRef.current.addEventListener('dataavailable', handleDataAvailable)
    mediaRecorderRef.current.start()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webcamRef, setCapturing, mediaRecorderRef])

  const handleDataAvailable = useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data))
      }
    },
    [setRecordedChunks]
  )

  useEffect(() => {
    if (preparing && recordedChunks.length > 0) showVideo()
  })

  const [showingVideo, setShowingVideo] = useState(null)
  const [preparing, setPreparing] = useState(false)
  const showVideo = () => {
    const blob = new Blob(recordedChunks, { type: mime })
    const url = URL.createObjectURL(blob)
    setData(url)
    setPreparing(false)
  }

  const [data, setData] = useState(null)
  const handleStopCaptureClick = useCallback(() => {
    mediaRecorderRef.current.stop()
    setCapturing(false)
    setShowingVideo(true)
    setPreparing(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaRecorderRef, webcamRef, setCapturing, recordedChunks])

  const sendVideo = () => {
    const blob = new Blob(recordedChunks, { type: mimeToSend })
    blob.lastModifiedDate = new Date()
    sendData(new File([blob], "capture.webm", { type: mimeToSend })).then(() => {
      setRecordedChunks([])
      setShowingVideo(false)
      setData(null)
    })
  }

  const switchCamera = async () => {
    const listOfVideoInputs = await getListOfVideoInputs()

    if (listOfVideoInputs.length > 1) {
      if (this.player.srcObject) {
        this.player.srcObject.getVideoTracks().forEach((track) => {
          track.stop()
        })
      }

      if (this.cameraNumber === 0) {
        this.cameraNumber = 1
      } else if (this.cameraNumber === 1) {
        this.cameraNumber = 0
      }

      this.initializeMedia()
    }
  }

  const getListOfVideoInputs = async () => {
    const enumerateDevices = await navigator.mediaDevices.enumerateDevices()
    return enumerateDevices.filter((device) => device.kind === "videoinput")
  }

  const options = {
    width: 768,
    height: 432,
    imageSmoothing: true,
    mirrored: true,
    audio: true,
    videoConstraints: {
      facingMode: 'user',
      width: 1280,
      height: 720,
    },
  }

  return (
    <Modal
      isOpen={showCamera}
      toggle={onToggleCamera}
      contentClassName='modal-camera'
      backdrop={'static'}
      header={
        <div className='modal-wrapper-header'>
          <h1>{I18n.t('dashboard_record-video')}</h1>
          <span onClick={onToggleCamera}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
          </span>
        </div>
      }
      body={
        showingVideo ? (
          <video key={data} width='768' height='432' controls>
            <source src={data} type={mime} />
            Your browser does not support HTML5 video.
          </video>
        ) : (
          <Webcam ref={webcamRef} {...options} />
        )
      }
      footer={
        <div style={{ margin: 'auto' }}>
          {capturing ? (
            <>
              <Button color='primary' onClick={handleStopCaptureClick} className='button-camera'>
                <img src="https://assets.nixi1.dkv.es/chatweb/images/square-solid.svg" alt='icon' />
              </Button>
            </>
          ) : (
            !showingVideo && (
              <>
                <Button color='primary' onClick={handleStartCaptureClick} className='button-camera'>
                  <img src="https://assets.nixi1.dkv.es/chatweb/images/video-white.svg" alt='icon' />
                </Button>
                {
                  getListOfVideoInputs().length > 0 &&
                  <Button color='primary' onClick={switchCamera} className='button-camera'>
                    <img src="https://assets.nixi1.dkv.es/chatweb/images/camera-rotate.svg" alt='icon' width='30px' />
                  </Button>
                }
              </>
            )
          )}

          {recordedChunks.length > 0 && (
            <>
              <Button color='primary' onClick={sendVideo} className='button-camera' disabled={uploading}>
                { uploading ? (
                  <Nixi1Spinner height='1em' width='1em'/>
                ) : (
                  <img src="https://assets.nixi1.dkv.es/chatweb/images/cloud-upload.svg" alt='icon'/>
                )}
              </Button>

              <Button
                color='primary'
                onClick={() => {
                  setRecordedChunks([])
                  setShowingVideo(false)
                }}
                className='button-camera'
              >
                <img src="https://assets.nixi1.dkv.es/chatweb/images/redo-alt-solid.svg" alt='icon'/>
              </Button>
            </>
          )}
        </div>
      }
    />
  )
}
